<template>
	<div class="invite-detail">
		<!-- Banner区域 -->
		<div class="banner">
			<div class="banner-content">
				<i class="el-icon-s-custom banner-icon"></i>
				<div class="banner-title">邀请好友</div>
				<div class="banner-subtitle">邀请好友注册，共享精彩时刻</div>
			</div>
		</div>
		
		<!-- 分享链接和邀请码区域 -->
		<div class="invite-info">
			<!-- 加载提示 -->
			<div class="loading-tip" v-if="loading" v-loading="loading">
				<span class="loading-text">加载中...</span>
			</div>
			
			<div class="invite-section">
				<div class="section-header">
					<i class="el-icon-link section-icon"></i>
					<span class="section-title">分享链接</span>
				</div>
				<div class="info-card">
					<span class="info-content">{{ shareLink }}</span>
					<el-button type="primary" size="small" @click="onCopyLink" icon="el-icon-document-copy">
						复制
					</el-button>
				</div>
			</div>
			
			<div class="invite-section">
				<div class="section-header">
					<i class="el-icon-present section-icon"></i>
					<span class="section-title">邀请码</span>
				</div>
				<div class="info-card">
					<span class="info-content code-content">{{ inviteCode }}</span>
					<el-button type="primary" size="small" @click="onCopyCode" icon="el-icon-document-copy">
						复制
					</el-button>
				</div>
			</div>
		</div>
		
		<!-- 推广记录列表 -->
		<div class="promotion-records">
			<div class="records-header">
				<span class="header-title">推广记录</span>
				<span class="header-count">直推 {{ directUserCount }} 人</span>
			</div>
			
			<div class="records-list" v-if="recordList.length > 0">
				<div class="record-item" v-for="(item, index) in recordList" :key="item.userId || index">
					<div class="record-left">
						<head-image :name="item.nickName" :url="item.headImageThumb" :size="50"></head-image>
						<div class="record-info">
							<div class="user-name">{{ item.nickName }}</div>
							<div class="join-time">{{ item.registerTime }}</div>
						</div>
					</div>
					<div class="record-right">
						<el-tag :type="item.status === 1 ? 'success' : 'info'" size="small">
							{{ item.status === 1 ? '通过' : '待审核' }}
						</el-tag>
					</div>
				</div>
			</div>
			
			<div class="empty-tip" v-else>
				<i class="el-icon-s-data"></i>
				<span class="empty-text">暂无推广记录</span>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
	name: "InviteDetail",
	components: {
		HeadImage
	},
	data() {
		return {
			// 邀请信息
			inviteInfo: {
				invitationCode: '',
				shareLink: ''
			},
			// 推广记录列表
			recordList: [],
			// 直推用户数量
			directUserCount: 0,
			// 加载状态
			loading: false
		}
	},
	computed: {
		userInfo() {
			return this.userStore.userInfo;
		},
		inviteCode() {
			return this.inviteInfo.invitationCode || '暂无邀请码';
		},
		shareLink() {
			return this.inviteInfo.shareLink || '暂无分享链接';
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			// 加载邀请信息
			this.loadInviteInfo();
			// 加载推广记录
			this.loadPromotionRecords();
		},
		// 加载邀请信息
		loadInviteInfo() {
			this.loading = true;
			this.$http({
				url: '/user/invitation/info',
				method: 'GET'
			}).then(data => {
				// request.js 中 code==200 时直接返回 data
				if (data) {
					this.inviteInfo = {
						invitationCode: data.invitationCode || '',
						shareLink: data.shareLink || ''
					};
				}
			}).catch(err => {
				console.error('获取邀请信息失败:', err);
				this.$message.error('获取邀请信息失败');
			}).finally(() => {
				this.loading = false;
			});
		},
		
		// 复制分享链接
		onCopyLink() {
			if (!this.inviteInfo.shareLink) {
				this.$message.warning('暂无分享链接');
				return;
			}
			
			// 使用现代浏览器的 Clipboard API
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(this.shareLink).then(() => {
					this.$message.success('链接已复制到剪贴板');
				}).catch(() => {
					this.$message.error('复制失败，请手动复制');
				});
			} else {
				this.$message.error('复制失败，请手动复制');
			}
		},
		
		// 复制邀请码
		onCopyCode() {
			if (!this.inviteInfo.invitationCode) {
				this.$message.warning('暂无邀请码');
				return;
			}
			
			// 使用现代浏览器的 Clipboard API
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(this.inviteCode).then(() => {
					this.$message.success('邀请码已复制到剪贴板');
				}).catch(() => {
					this.$message.error('复制失败，请手动复制');
				});
			} else {
				this.$message.error('复制失败，请手动复制');
			}
		},
		
		// 加载推广记录
		loadPromotionRecords() {
			this.$http({
				url: '/user/invitation/records',
				method: 'GET'
			}).then(data => {
				if (data) {
					// 设置推广记录列表
					this.recordList = data.records || [];
					// 设置直推用户数量
					this.directUserCount = data.directUserCount || 0;
				}
			}).catch(err => {
				console.error('获取推广记录失败:', err);
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.invite-detail {
	background: #f5f7fa;
	min-height: 100%;
	padding: 15px;
	
	// Banner区域
	.banner {
		position: relative;
		width: 100%;
		height: 200px;
		overflow: hidden;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		border-radius: 12px;
		margin-bottom: 15px;
		
		.banner-content {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			
			.banner-icon {
				font-size: 50px;
				color: white;
				margin-bottom: 15px;
				opacity: 0.9;
			}
			
			.banner-title {
				font-size: 24px;
				font-weight: bold;
				color: white;
				margin-bottom: 10px;
			}
			
			.banner-subtitle {
				font-size: 14px;
				color: rgba(255, 255, 255, 0.9);
			}
		}
	}
	
	// 邀请信息区域
	.invite-info {
		
		.loading-tip {
			text-align: center;
			padding: 10px;
			color: var(--im-text-color-light);
			font-size: 13px;
		}
		
		.invite-section {
			margin-bottom: 15px;
			
			.section-header {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
				
				.section-icon {
					font-size: 16px;
					color: var(--im-color-primary);
					margin-right: 5px;
				}
				
				.section-title {
					font-size: 15px;
					font-weight: 600;
					color: var(--im-text-color);
				}
			}
			
			.info-card {
				background: white;
				border-radius: 10px;
				padding: 15px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
				
				.info-content {
					flex: 1;
					font-size: 13px;
					color: var(--im-text-color);
					word-break: break-all;
					margin-right: 10px;
				}
				
				.code-content {
					font-size: 18px;
					font-weight: bold;
					color: var(--im-color-primary);
					letter-spacing: 2px;
				}
			}
		}
	}
	
	// 推广记录区域
	.promotion-records {
		
		.records-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
			
			.header-title {
				font-size: 15px;
				font-weight: 600;
				color: var(--im-text-color);
			}
			
			.header-count {
				font-size: 12px;
				color: var(--im-text-color-light);
			}
		}
		
		.records-list {
			.record-item {
				background: white;
				border-radius: 10px;
				padding: 15px;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
				
				.record-left {
					display: flex;
					align-items: center;
					flex: 1;
					
					.record-info {
						margin-left: 10px;
						display: flex;
						flex-direction: column;
						
						.user-name {
							font-size: 14px;
							font-weight: 500;
							color: var(--im-text-color);
							margin-bottom: 5px;
						}
						
						.join-time {
							font-size: 12px;
							color: var(--im-text-color-light);
						}
					}
				}
				
				.record-right {
					margin-left: 10px;
				}
			}
		}
		
		.empty-tip {
			background: white;
			border-radius: 10px;
			padding: 50px 15px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
			
			i {
				font-size: 60px;
				color: var(--im-text-color-lighter);
				margin-bottom: 10px;
			}
			
			.empty-text {
				font-size: 14px;
				color: var(--im-text-color-light);
			}
		}
	}
}
</style>

